import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  BackgroundImage,
  Row, Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { checkGreen } from '../../../../../../../assets/Base64Image';
import { Box, Driver, Order } from '../../../../../../../lib/types';
import { getFoodifoxData, updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import ProblemReportModal from '../../../../../Common/ProblemReportModal';
import NoFreeBoxModal from '../../../../../Common/NoFreeBoxModal';
import ReopenButton from '../../../../../Common/ReopenButton';
import OpenedBox from '../../../../../Common/OpenedBox/Driver';
import { getCabId32Str } from '../../../../../../../lib/utils/utils';

const OpenBoxSuccess: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  roomNo,
  platform,
  orderId,
  setSelectedPlatform,
  setOpenedBoxes,
  openedBoxes,
}) => {
  const [reopenBoxLazy, { loading: reopenLoading }] = updateFoodifoxData('/foxH5Driver/reopenOrderBoxByRoomNo');
  const [saveReasonLazy, { loading: saveReasonLoading }] = updateFoodifoxData<{ cabSizeType: string; openBoxes: Box[] }>('/foxH5RentLog/saveCannotUseCabReason');
  const { data: orderData, loading: getOrderDataLoading, refetch: refetchOrder } = getFoodifoxData<Order>('/foxWebH5Order/getById?orderId=' + orderId);
  const { data: orderDateData, loading: checkSaveTimeLoading } = getFoodifoxData<{ saveCabDate: string }>('/foxH5Check/getOrderSaveCabDate', { orderId });

  const timeWaitRef = useRef<number>();

  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [showProblemModal, setShowProblemModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(reopenLoading || checkSaveTimeLoading || saveReasonLoading || getOrderDataLoading);

    return () => {
      setShowLoading(false);
    };
  }, [reopenLoading, checkSaveTimeLoading, saveReasonLoading, getOrderDataLoading]);

  useEffect(() => {
    if (orderDateData && orderDateData.saveCabDate) {
      const time = 60 - (new Date().getTime() - new Date(orderDateData.saveCabDate.replace(/-/g, '/')).getTime()) / 1000;
      timeWaitRef.current = time < 0 ? 0 : time;
      setTimeWait(timeWaitRef.current.toFixed(0));
    }
  }, [orderDateData]);

  useEffect(() => {
    setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = 0;
        setTimeWait('0');
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);
  }, []);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    // 超过1分钟后，需要去到重新开门页面
    if (timeWaitRef.current == null || timeWaitRef.current <= 0) {
      setSelectedPlatform(undefined);
      setTargetPage('platform-select-reopen-box');
      return;
    }

    if (orderData) {
      reopenBoxLazy({
        param: {
          cabId: getCabId32Str(orderData.useCabId),
          roomNo,
          driverId,
          platform,
        },
      });
    }
  };

  return (
    <BackgroundImage>
      {
        showProblemModal && (
          <ProblemReportModal
            onClose={() => setShowProblemModal(false)}
            onConfirm={(reason) => {
              if (orderData) {
                setShowProblemModal(false);
                saveReasonLazy({
                  param: {
                    cabId: getCabId32Str(orderData.useCabId),
                    boxNumbers: JSON.stringify(openedBoxes.map((box) => box.boxNumber)),
                    reportUser: 'Driver',
                    driverId,
                    reason,
                  },
                  onError() {
                    setShowNoFreeBoxModal(true);
                  },
                  onCompleted({ openBoxes }) {
                    refetchOrder();
                    setOpenedBoxes(openBoxes);
                  },
                });
              }
            }}
            isEnglish={isEnglish}
            optionKeys={['Dirty', 'Door is not working', 'Other']}
          />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal onClose={() => setShowNoFreeBoxModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
        showSupport={false}
        showHome={true}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      <div style={{ marginTop: '30px', marginLeft: 'auto', marginRight: 'auto', width: '335px', background: '#FFFFFF', borderRadius: '15px', border: '1px solid #11202B', padding: '25px 0' }}>
        <div>
          {
            isEnglish ? (
              <div style={{ fontSize: '30px', fontFamily: 'Squad-ExtraBold, Squad', fontWeight: 800, color: '#FBC0CB', textAlign: 'center' }}>
                Contact customer
              </div>
            ) : (
              <div style={{ fontSize: '26px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FBC0CB', textAlign: 'center' }}>
                联系取餐人
              </div>
            )
          }
        </div>

        {/* 分割线 */}
        <div style={{ width: '295px', height: '1px', background: '#11202B', opacity: 0.1, marginTop: '25px', marginLeft: 'auto', marginRight: 'auto' }}></div>

        {
          isEnglish ? (
            <>
              <div style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', textAlign: 'center', marginTop: '20px' }}>
                MUST inform customer to use
              </div>
              <div style={{ fontSize: '20px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', textAlign: 'center', marginTop: '10px' }}>
                Unit No.
              </div>
              <div style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', textAlign: 'center', marginTop: '10px' }}>
                to open the locker door.
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', textAlign: 'center', marginTop: '20px' }}>
                司机必须告知顾客使用
              </div>
              <div style={{ fontSize: '24px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', textAlign: 'center', marginTop: '10px', textDecoration: 'underline' }}>
                公寓门牌号
              </div>
              <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', textAlign: 'center', marginTop: '10px' }}>
                打开柜门取餐
              </div>
            </>
          )
        }
      </div>

      {/* 柜子打开的柜门 */}
      {
        openedBoxes.map((box) => (
          <OpenedBox
            key={box.boxNumber}
            width={335}
            boxNumber={box.boxNumber}
            isEnglish={isEnglish}
            cabSizeType={box.cabSizeType}
            lockAddress={box.lockNumber}
            lockPort={box.lockPort}
            style={{
              margin: '21px auto 21px auto',
              textAlign: 'center',
              background: '#FFFFFF',
              borderRadius: '20px',
              border: '1px solid rgba(17,32,43,0.1)',
            }}
          />
        ))
      }

      <div style={{ width: '335px', margin: '21px auto 50px auto', padding: '25px 0', textAlign: 'center', background: '#FFFFFF', borderRadius: '20px', border: '1px solid rgba(17,32,43,0.1)' }}>
        <Row style={{ justifyContent: 'space-between', marginLeft: '19px', marginRight: '19px' }}>
          {/* 重新打开柜门 */}
          <ReopenButton
            onClick={() => reopenBox()}
            isEnglish={isEnglish}
            timeWait={timeWait}
          />

          {/* 不能使用柜门，弹出反馈窗口，然后重新打开新柜门 */}
          <Button
            onClick={() => setShowProblemModal(true)}
            style={{ width: '140px', height: '47px', background: '#D0D0D0', borderRadius: '23px' }}>
            {
              isEnglish ? (
                <div style={{ fontSize: '14px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '19px' }}>
                  Report problems
                </div>
              ) : (
                <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '20px' }}>
                  反馈柜子问题
                </div>
              )
            }
          </Button>
        </Row>

        {/* 柜门信息 */}
        <div style={{ margin: '40px auto 0 auto', width: '142px', height: '68px', background: '#F3F3F3', borderRadius: '12px', textAlign: 'center' }}>
          <img src={checkGreen} style={{ width: '36px', marginTop: '-18px' }} />
          {
            isEnglish ? (
              <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '24px' }}>
                Door #{openedBoxes[0].boxNumber}
              </div>
            ) : (
              <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '25px' }}>
                柜门编号 #{openedBoxes[0].boxNumber}
              </div>
            )
          }
        </div>
      </div>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  roomNo: string;
  platform: number;
  orderId: number;
  setSelectedPlatform: (platform?: number) => void;
  setOpenedBoxes: (openedBoxes: Box[]) => void;
  openedBoxes: Box[];
}

export default OpenBoxSuccess;
